import Vuex from 'vuex'
var noticeUtils = {
  $app: null
}
noticeUtils.confirm = function (msg, buttonStatus, fn) {
  let __self = this;
  let dialogConfig = {
    buttons: []
  }
  if (buttonStatus == undefined) {
    dialogConfig.buttons.push({
      title: '',
      name:'share.confirmTxt',
      affair: function () {
        dialogConfig.status = false;
        fn(true)
      }
    })
    dialogConfig.mess = msg;
    dialogConfig.status = true;
    __self.$app.$store.dispatch('diologConfig', dialogConfig);
    return;
  }
  dialogConfig.buttons.push({
    title: '',
    name:'share.cancelTxt',
    affair: function () {
      dialogConfig.status = false;
      fn(false);
    }
  }, {
    title: '',
    name:'share.confirmTxt',
    affair: function () {
      dialogConfig.status = false;
      fn(true);
    }
  })
  dialogConfig.mess = msg;
  dialogConfig.status = true;
  __self.$app.$store.dispatch('diologConfig', dialogConfig);
}
noticeUtils.fail = function (msg, types, fn) {
  let __self = this;
  let dialogConfig = {};
  if (types == 'fail' && fn == undefined) {
    dialogConfig.mess = msg;
    dialogConfig.status = true;
    dialogConfig.types = types;
    __self.$app.$store.dispatch('diologConfig', dialogConfig);
    setTimeout(function () {
      dialogConfig.status = false;
    }, 1000)
  }
}
noticeUtils.succ = function (msg, types, fn) {
  let __self = this;
  let dialogConfig = {};
  if (types == 'succ' && fn == undefined) {
    dialogConfig.mess = msg;
    dialogConfig.status = true;
    dialogConfig.types = types;
    __self.$app.$store.dispatch('diologConfig', dialogConfig);
    setTimeout(function () {
      dialogConfig.status = false;
    }, 1000)
  }
}
noticeUtils.Loading = {
  open: function (title, BgColor) {
    let __self = $utils;
    let loadConfig = {
      status: true,
      title: title == undefined ? 'load' : title,
      BgColor: BgColor
    };
    __self.$app.$store.dispatch('loadConfig', loadConfig);
  },
  close: function (title) {
    let __self = $utils;
    let loadConfig = {
      status: false,
      title: title == undefined ? 'load' : title
    };
    __self.$app.$store.dispatch('loadConfig', loadConfig);
  }
}
export default noticeUtils;



// WEBPACK FOOTER //
// ./src/utils/noticeUtils.js